import React from 'react'
import DefaultDashboardContainer from '../../../Components/Dashboard/DefaultDashboard'

export default function DefaultDashboard() {
  return (
    <div className='page-body'>
        <DefaultDashboardContainer/>
    </div>
  )
}
